export default function Divider(){
    return(
        <div className="flex justify-center items-center py-[30px]">
            <hr className='border-t-2 border-gray-400 opacity-40 w-[100%]'/>
        </div>
    )
}